export default {
  'menu.workbench': 'ようこそ',
  'menu.more-blocks': 'その他のブロック',
  'menu.home': 'ホーム',
  'menu.admin': '管理者',
  'menu.admin.sub-page': 'サブページ',
  'menu.project-center': 'プロジェクト管理',
  'menu.project-center.workbench': 'ワークベンチ',
  'menu.project-center.project-overview': 'プロジェクト概要',
  'menu.project-center.project-space': 'プロジェクト空間',
  'menu.project-center.my-tasks': '自分のタスク',
  'menu.project-center.my-projects': '自分のプロジェクト',
  'menu.project-center.dashboard': '問題センター',
  'menu.project-center.boards': '全体カンバン',
  'menu.project-center.gantt': '全体ガントチャート',
  'menu.project-center.projects': 'プロジェクト一覧',
  'menu.project-center.resources': 'リソースセンター',
  'menu.project-center.calendar': 'カレンダー',
  'menu.project-center.risks': 'リスクセンター',
  'menu.project-center.analytics': '分析',
  'menu.template-center': 'テンプレートセンター',
  'menu.template-center.detail': 'テンプレート詳細',
  'menu.system': 'システム設定',
  'menu.system.permissions': '権限管理',
  'menu.system.dictionary': 'データ辞書',
  'menu.system.ai-model-binding': 'モデル連携',
  'menu.project-center.project-detail': 'プロジェクトワークスペース',
  'menu.project-center.project-detail.overview': 'プロジェクト概要',
  'menu.project-center.project-detail.kanban': 'タスク管理',
  'menu.project-center.project-detail.gantt': 'プロジェクト進捗',
  'menu.project-center.project-detail.delivery': '文書資料',
  'menu.project-center.project-detail.acceptance': '検収',
  'menu.project-center.project-detail.communication': 'コミュニケーション',
  'menu.project-center.project-detail.members': 'メンバー協働',
  'menu.project-center.project-detail.work-hours': 'プロジェクト統計',
  'menu.project-center.project-detail.issues': 'リスク問題',
  'menu.project-center.project-detail.report': 'プロジェクト報告',
  'menu.project-center.project-detail.review': 'レビュー',
  'menu.project-center.project-detail.activities': 'プロジェクト動向',
  'menu.login': 'ログイン',
  'menu.dashboard': 'ダッシュボード',
  'menu.dashboard.analysis': '分析',
  'menu.dashboard.monitor': 'モニター',
  'menu.dashboard.workplace': '職場',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'フォーム',
  'menu.form.basic-form': '基本フォーム',
  'menu.form.step-form': 'ステップフォーム',
  'menu.form.step-form.info': 'ステップフォーム（転送情報の書き込み）',
  'menu.form.step-form.confirm': 'ステップフォーム（転送情報の確認）',
  'menu.form.step-form.result': 'ステップフォーム（完成）',
  'menu.form.advanced-form': '高度なフォーム',
  'menu.list': 'リスト',
  'menu.list.table-list': '検索テーブル',
  'menu.list.basic-list': '基本リスト',
  'menu.list.card-list': 'カードリスト',
  'menu.list.search-list': '検索リスト',
  'menu.list.search-list.articles': '検索リスト(記事)',
  'menu.list.search-list.projects': '検索リスト(プロジェクト)',
  'menu.list.search-list.applications': '検索リスト(アプリ)',
  'menu.profile': 'プロフィール',
  'menu.profile.basic': '基本プロフィール',
  'menu.profile.advanced': '高度なプロフィール',
  'menu.result': '結果',
  'menu.result.success': '成功',
  'menu.result.fail': '失敗',
  'menu.exception': '例外',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'トリガー',
  'menu.account': 'アカウント',
  'menu.account.center': 'アカウントセンター',
  'menu.account.workbench': 'ワークベンチに戻る',
  'menu.account.tenantManagement': 'テナント管理',
  'menu.account.trigger': 'トリガーエラー',
  'menu.account.logout': 'ログアウト',
  'menu.editor': 'グラフィックエディタ',
  'menu.editor.flow': 'フローエディタ',
  'menu.editor.mind': 'マインドエディター',
  'menu.editor.koni': 'コニエディター',
};
